module.exports = __webpack_public_path__ + "img/f_c_sc_2.d58d8919.png";